<form class="dialog ng-submitted" #form="ngForm" (submit)="onSubmit($event, form)">
    <div class="dialog-body">
        <app-loading *ngIf="loading"></app-loading>

        <div class="credentials" *ngIf="!loading">
            <div class="credential-item" [ngClass]="{ closed: !opened.basic }">
                <div class="credential-header">
                    <input name="basic" value="basic" type="checkbox"  [checked]="opened.basic" [(ngModel)]="opened.basic">
                    <h2>{{ 'technicals.webhooks.heading.basic' | translate }}</h2>
                </div>
                <div class="credential-body">
                    <div class="form-row form-required">
                        <label>{{ 'shared.label.username' | translate }}</label>
                        <input
                            autocomplete="new-password"
                            id="new-username"
                            name="new-username"
                            type="text"
                            spellcheck="off"
                            [required]="opened.basic"
                            [(ngModel)]="modelBasic.username">
                    </div>
                    <div class="form-row form-required">
                        <label>{{ 'shared.label.password' | translate }}</label>
                        <input

                            autocomplete="new-password"
                            id="new-password"
                            name="new-password"
                            type="password"
                            spellcheck="off"
                            [required]="opened.basic"
                            [(ngModel)]="modelBasic.password">
                    </div>
                </div>
            </div>

            <div class="credential-item" [ngClass]="{ closed: !opened.hmac }">
                <div class="credential-header">
                    <input name="hmac" value="hmac" type="checkbox" [checked]="opened.hmac" [(ngModel)]="opened.hmac">
                    <h2>{{ 'technicals.webhooks.heading.hmac' | translate }}</h2>
                </div>
                <div class="credential-body">
                    <div class="form-row form-required">
                        <label>{{ 'shared.label.secret' | translate }}</label>
                        <input
                            id="new-secret"
                            spellcheck="off"
                            type="text"
                            name="new-secret"
                            [required]="opened.hmac"
                            [pattern]="'^[a-zA-Z0-9]{32,}$'"
                            [(ngModel)]="modelHmac.secret">
                    </div>
                    <div class="form-hint">{{ 'technicals.webhooks.secret-hint' | translate }}</div>
                </div>
            </div>

            <div class="credential-item" [ngClass]="{ closed: !opened.header }">
                <div class="credential-header">
                    <input name="header" value="header" type="checkbox"  [checked]="opened.header" [(ngModel)]="opened.header">
                    <h2>{{ 'technicals.webhooks.heading.header' | translate }}</h2>
                </div>
                <div class="credential-body">
                    <div class="form-row form-required">
                        <label>{{ 'shared.label.key' | translate }}</label>

                        <div class="form-group">
                            <div class="form-prepend">
                                {{ this.modelHeader.prefix }}-
                            </div>
                            <input
                                id="new-key"
                                spellcheck="off"
                                type="text"
                                name="new-key"
                                [required]="opened.header"
                                [pattern]="'^[a-zA-Z0-9-]+$'"
                                [(ngModel)]="modelHeader.key">
                        </div>
                    </div>
                    <div class="form-row form-required">
                        <label>{{ 'shared.label.value' | translate }}</label>
                        <input
                            id="new-value"
                            spellcheck="off"
                            type="text"
                            name="new-value"
                            [required]="opened.header"
                            [pattern]="'^[A-Za-z0-9-_=]+\.[A-Za-z0-9-_=]+\.?[A-Za-z0-9-_.+/=]*'"
                            [(ngModel)]="modelHeader.value">
                    </div>
                </div>
            </div>
        </div>

        <div class="buttons">
            <a class="button button-basic-primary" (click)="onCancel()">{{ 'shared.button.cancel' | translate }}</a>
            <button type="submit" [disabled]="form.invalid" class="button button-primary">
                {{ 'shared.button.confirm' | translate }}
            </button>
        </div>
    </div>
</form>

